import OwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
export default function PortfolioTwo(){
    return(
        <>
        <section id="projects" className="case-study-area case-bg2 nav-style-1 pt-115 pt-md-60 pt-xs-60">
			<div className="container">
				<div className="row">
					<div className="col-lg-6">
						<div className="core-feature-title text-md-start">
							<p className="text-white">Good Portfolio</p>
							<h2 className="sect-title text-white">Our Case Studies</h2>
						</div>
					</div>
				</div>
				
                <OwlCarousel items={3}  
			className="owl-theme cases-slide2"  
			loop 
			dots={false}
			nav={true}
			navText={[
				'<span class="arrow prev"><i class="fal fa-long-arrow-left"></i></span>',
				'<span class="arrow next"><i class="fal fa-long-arrow-right"></i></span>'
			  ]}		  
			margin={30}
			responsive= {
				{
					'1':{
						items: 1
					},
					'768': {
						items: 2
					},

					'1200': {
						items: 3
					}

				}
				
			} >
					<div className="item">
						<div className="cases-wrapper2">
							<img src="assets/img/case/case-5.jpg" alt="Image" />
							<h6>UI & UX, IT Solution</h6>
							<h5 className="fs-20 text-heding3">Smartrics Web Solution</h5>
							<p>Lorem ipsum dolor sit amet, conse
								ctetur a dipisicing elit</p>
							<Link to="/services-details" className="read-more">Case Details <span className="f-right"><i
										className="fal fa-long-arrow-right"></i></span></Link>
						</div>
					</div>
					<div className="item">
						<div className="cases-wrapper2">
							<img src="assets/img/case/case-6.jpg" alt="Image" />
							<h6>UI & UX, IT Solution</h6>
							<h5 className="fs-20 text-heding3">Smartrics Web Solution</h5>
							<p>Lorem ipsum dolor sit amet, conse
								ctetur a dipisicing elit</p>
							<Link to="/services-details" className="read-more">Case Details <span className="f-right"><i
										className="fal fa-long-arrow-right"></i></span></Link>
						</div>
					</div>
					<div className="item">
						<div className="cases-wrapper2">
							<img src="assets/img/case/case-7.jpg" alt="Image" />
							<h6>UI & UX, IT Solution</h6>
							<h5 className="fs-20 text-heding3">Smartrics Web Solution</h5>
							<p>Lorem ipsum dolor sit amet, conse
								ctetur a dipisicing elit</p>
							<Link to="/services-details" className="read-more">Case Details <span className="f-right"><i
										className="fal fa-long-arrow-right"></i></span></Link>
						</div>
					</div>
					<div className="item">
						<div className="cases-wrapper2">
							<img src="assets/img/case/case-8.jpg" alt="Image" />
							<h6>UI & UX, IT Solution</h6>
							<h5 className="fs-20 text-heding3">Smartrics Web Solution</h5>
							<p>Lorem ipsum dolor sit amet, conse
								ctetur a dipisicing elit</p>
							<Link to="/services-details" className="read-more">Case Details <span className="f-right"><i
										className="fal fa-long-arrow-right"></i></span></Link>
						</div>
					</div>
					<div className="item">
						<div className="cases-wrapper2">
							<img src="assets/img/case/case-6.jpg" alt="Image" />
							<h6>UI & UX, IT Solution</h6>
							<h5 className="fs-20 text-heding3">Smartrics Web Solution</h5>
							<p>Lorem ipsum dolor sit amet, conse
								ctetur a dipisicing elit</p>
							<Link to="/services-details" className="read-more">Case Details <span className="f-right"><i
										className="fal fa-long-arrow-right"></i></span></Link>
						</div>
					</div>
				</OwlCarousel>
				<div className="row pt-50">
					<div className="col-12 text-center">
						<p className="text mb-20 lh-1">Challenges are just opportunities in disguise. <b>
                            <Link className="text-heding3" to="/contact">Take the challenge!</Link></b></p>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}